import { createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { UsersPanel } from "../components/settings/users/UsersPanel";

export const Route = createFileRoute("/_auth/staff")({
  staticData: { titleKey: "nav.staff", breadcrumbKey: "breadcrumb.manage", breadcrumbN: 1 },
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (me && !me.permissions?.includes("manage_users")) {
      throw redirect({ to: "/clients" });
    }
  },
  component: UsersPanel,
});
